import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

const Layout = ({ children, auth: { isAuthenticated } }) => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(Layout);
